import { useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGIN_ID_HEADER, ORG_ID_HEADER } from '../../types/auth.types';
import useFranchiseeAlias from '../../utils/useFranchiseeAlias/useFranchiseeAlias';
import useLocalUser from '../../utils/useLocalUser/useLocalUser';
import Button from '../Button/Button';
import { ButtonVariants } from '../Button/Button.types';
import Modal from '../Modal/Modal';
import styles from './FranchiseeAliasBanner.module.css';
import { useSTKContext } from '@/context/context';

const FranchiseeAliasBanner: FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { setUser } = useLocalUser();
  const { alias, removeAlias, actualUser } = useFranchiseeAlias();
  const { apiClient } = useSTKContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const closeModal = () => setModalIsOpen(false);
  const openModal = () => setModalIsOpen(true);

  const handleClick = () => {
    delete apiClient.defaults.headers.common[ORG_ID_HEADER];
    delete apiClient.defaults.headers.common[LOGIN_ID_HEADER];
    setUser(actualUser);
    removeAlias();
    queryClient.invalidateQueries(['current-user']);
    navigate('/franchiseeportal');
    window.location.reload();
  };

  return (
    <div className={styles.banner} data-testid="fz-alias-banner">
      <div className={styles.message}>
        You are in Organization <span className={styles.bold}>{alias?.fzCode}</span>&apos;s space
      </div>
      <button onClick={openModal} className={styles.button} type="button">
        Exit
      </button>
      <Modal
        className={styles.modal}
        isOpen={modalIsOpen}
        onClose={closeModal}
        headerContent="Are you sure you want to leave this space?"
        footerContent={
          <div className={styles.modalButtons}>
            <Button variant={ButtonVariants.Secondary} onClick={closeModal}>
              Cancel
            </Button>
            <Button onClick={handleClick}>Confirm</Button>
          </div>
        }
      />
    </div>
  );
};

export default FranchiseeAliasBanner;
